import {
  Download,
  FileDown,
  FileText,
  SquareArrowOutUpRight,
} from 'lucide-react';

import { formatFileSize } from '@virtual-care/isomorphic';
import { DownloadFile, ViewFile } from '@virtual-care/media-web';

type AttachedFile = {
  id: string;
  fileId: string;
  file: { name: string; contentType: string; size: number };
};

export function AttachedFiles({ files }: { files: AttachedFile[] }) {
  return (
    <div className="bg-muted/50 rounded-lg p-4">
      <h3 className="mb-3 flex items-center gap-2 font-semibold">
        <FileText className="h-4 w-4" />
        Attached Files ({files.length})
      </h3>
      <div className="space-y-2">
        {files.map((file) => (
          <FileItem key={file.id} file={file} />
        ))}
      </div>
    </div>
  );
}

function FileItem({ file }: { file: AttachedFile }) {
  return (
    <div className="bg-background flex items-center justify-between rounded border p-2">
      <div className="flex items-center gap-2">
        <FileDown className="text-muted-foreground h-4 w-4" />
        <span className="text-sm font-medium">{file.file.name}</span>
        <span className="text-muted-foreground text-xs">
          ({file.file.contentType})
        </span>
        {file.file.size > 0 && (
          <span className="text-muted-foreground text-xs">
            {formatFileSize(file.file.size)}
          </span>
        )}
      </div>
      <div className="flex items-center gap-2">
        <ViewFile
          fileId={file.fileId}
          variant="outline"
          size="sm"
          icon={<SquareArrowOutUpRight className="h-4 w-4" />}
        >
          View
        </ViewFile>
        <DownloadFile
          fileId={file.fileId}
          variant="outline"
          size="sm"
          icon={<Download className="h-4 w-4" />}
        >
          Download
        </DownloadFile>
      </div>
    </div>
  );
}
